// Required modules
import GenericTable from "components/Tables/GenericTable";
import Form from "components/Forms/Form.jsx";

// Config admin class
import ConfigAdmin from "../ConfigAdmin.js";

// Hooks
import { useEffect, useState } from "react";
import useForm from "hooks/useForm.jsx";

// Necessary data
import {
  headersTableLibraryPoint,
  keyValuesTableLibraryPoint,
  initialValuesFormLibraryPoint,
} from "../dataConfigAdmin";

// Styles
import {
  ColumnAdminConfig,
  RowAdminConfig,
  CreateNewRegionButton,
  SeparatorWithText,
  InformationShare,
  IconAdminConfigChangeColum,
} from "../configAdminStyles";
import { IoMdAdd } from "react-icons/io";
import { BsChevronCompactUp } from "react-icons/bs";
import { ContainerForm } from "components/Forms/FormStyles";
import Fields from "pages/ConfigAdmin/typeElemts/Fields.jsx";
import { TYPE_FIELDS } from "utils/constStrings.jsx";
// Button to render before of title in form
const ButtonSeeInitalView = ({ click }) => {
  const some = () => {
    click();
  };

  return (
    <IconAdminConfigChangeColum onClick={some}>
      <BsChevronCompactUp />
    </IconAdminConfigChangeColum>
  );
};

export default function EventLibraries({ setOpenDialog, setContentDialog }) {
  // Config admin object
  const [configAdmin, setConfigAdmin] = useState(null);
  const [seeForm, setSeeForm] = useState(false);
  const [select] = useState(1); // id: 1 -> default parametrized library

  // Everything related to the form
  let [form, methodsForm] = useForm(initialValuesFormLibraryPoint);
  const { handleChangeForm, changeFormForSpecificValues, clearField } =
    methodsForm;
  const [buttonsForm, setButtonsForm] = useState([]);
  // State button loadingCreate
  const [loadingCreate, setLoadingCreate] = useState(false);
  const [loadingDelete, setLoadingDelete] = useState(false);

  // Necessary functions in the config admin of the form
  if (configAdmin) {
    configAdmin.setChangeFormForSpecificValues(changeFormForSpecificValues);
    configAdmin.setOnChangeFields(handleChangeForm);
  }

  // Rows of table
  const [libreriesRows, setLibreriesRows] = useState([]);

  // Click  on type element ghg into table
  const handleClickLibrary = (id) => {
    configAdmin.handlerClickIntoTable(id);
  };

  // Set type library id
  // useEffect(() => {
  //   setSelect(form?.typeLibraryId?.value);
  // }, [setSelect, form]);

  // Create object to config admin and set it
  useEffect(() => {
    const configAdmin = new ConfigAdmin();
    configAdmin.setHeadersTable(headersTableLibraryPoint);
    configAdmin.setKeyValuesTable(keyValuesTableLibraryPoint);
    configAdmin.setSetRows(setLibreriesRows);
    configAdmin.setSetButtons(setButtonsForm);
    configAdmin.setSetSeeForm(setSeeForm);
    configAdmin.setSetLoadingCreate(setLoadingCreate);
    configAdmin.setSetLoadingDelete(setLoadingDelete);
    configAdmin?.setEndpoint(`api/v1/point-library-events`);
    configAdmin?.setDialog(setOpenDialog, setContentDialog);
    setConfigAdmin(configAdmin);
    setButtonsForm([configAdmin.buttonCreate]);
  }, [setOpenDialog, setContentDialog]);

  // Set library in config admin
  useEffect(() => {
    configAdmin?.setEndpointFetch(`api/v1/point-library-events`);
    configAdmin?.fetchData();
  }, [configAdmin]);

  // Set type library
  useEffect(() => {
    configAdmin?.setSelect(select);
  }, [configAdmin, select]);

  // Field forms of config admin
  useEffect(() => {
    configAdmin && configAdmin.setFieldForm(form);
  }, [form, configAdmin]);

  // Clear fields form
  useEffect(() => {
    configAdmin && configAdmin.setClearFields(clearField);
  }, [clearField, configAdmin]);

  return (
    <RowAdminConfig>
      <ColumnAdminConfig>
        {configAdmin && (
          <GenericTable
            headers={configAdmin.getHeadersTable()}
            rows={libreriesRows}
            keyValues={configAdmin.getKeyValuesTable()}
            handlerClick={handleClickLibrary}
            style={{
              width: 100,
            }}
            state={true}
          />
        )}
      </ColumnAdminConfig>
      <ColumnAdminConfig>
        <ContainerForm see={seeForm}>
          <Form
            form={form}
            // setSelect={setSelect}
            // select={select}
            handleChange={handleChangeForm}
            handleRows={handleClickLibrary}
            buttons={buttonsForm}
            loadingCreate={loadingCreate}
            loadingDelete={loadingDelete}
            renderBeforeTitle={[
              <ButtonSeeInitalView click={() => configAdmin.toggleForm()} />,
            ]}
            renderBeforeButtons={[
              <Fields
                typeFields={TYPE_FIELDS.typeToLibrary}
                form={form}
                handleChange={handleChangeForm}
              />,
            ]}
            title={"Create a new Digital Twin Library"}
          />
        </ContainerForm>

        {!seeForm && (
          <>
            <CreateNewRegionButton>
              Create a new Digital Twin Library
              <button onClick={() => configAdmin.toggleForm()}>
                <span>
                  <IoMdAdd />
                </span>
                New Type Library
              </button>
            </CreateNewRegionButton>

            <SeparatorWithText>
              <span className="left"></span>
              Or
              <span className="right"></span>
            </SeparatorWithText>

            <InformationShare>
              <div className="head">Edit Existing Digital Twin Library</div>
              <div className="body">
                To Edit Click on Existing Digital Twin Library ID
              </div>
            </InformationShare>
          </>
        )}
      </ColumnAdminConfig>
    </RowAdminConfig>
  );
}
